module.exports = __webpack_public_path__ + "static/media/yasmine-sidhom.4f89d344.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/yasmine-sidhom.jpg
// module id = 1839
// module chunks = 0